import { icon } from "../functions/icons";

export function NotificationComp({title,active,onClick}){
    return(
        <div onClick={onClick} className="horizontal standard-margin-left setting-notification">
            {(active)?icon('off'):icon("on")}
            <p className="small-text-dark standard-bold">{title}</p>
        </div>
    )
}